import { buildWebRouteKey } from '@utils/app-message-routes';
import { useParams, useRouteMatch } from 'react-router';

/**
 * The `App_Messages` route key for the screen currently rendered (ENVDB-7836): the declaring
 * `<Route>`'s path pattern with `:section` substituted from the URL, `:id` left literal.
 *
 * One hook for both the single mount and the publishing pages, so the two can never compute the
 * key differently — the mount only honours a publication whose route equals its own.
 *
 * Must be called inside a `<Route>`; `useRouteMatch()` returns the nearest one's match. That is
 * the case for everything rendered through `ProtectedRoute`, including `/admin`, because
 * `<Switch>` supplies the computed match to the inner `<Route>`.
 */
export const useWebRouteKey = (): string => {
    const { path } = useRouteMatch();
    const { section } = useParams<{ section?: string }>();
    return buildWebRouteKey(path, section);
};

export default useWebRouteKey;
